(function() {
  'use strict';

  angular
    .module('admin.publishers.users', [
    ])
    .controller('PublisherUserAdminCtrl', PublisherUserAdminCtrl);

  /** @ngInject */
  function PublisherUserAdminCtrl($scope, $location, $stateParams, PublisherAdminService, UsersService) {
    var vm = this;
    vm.items = [];
    vm.isView = false;
    vm.create = false;
    var view = $location.$$path.indexOf('view') !== -1;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
        current: 1
    };

    var newUsers = [];

    function load(pageNumber){
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }
      UsersService.getAll(vm.oldPage, 25).then(function(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        var users = result.results;

        if (view) {
          vm.isView = true;
          for (var i = 0; i < users.length; i++) {
            users[i].editing = false;
            if (users[i].producer !== undefined){
              if (users[i].producer['id-pu'] === parseInt($stateParams.parentId)) {
                newUsers.push(users[i]);
              }
            }
          }
        } else {
          vm.isView = false;
          for (var j = 0; j < users.length; j++) {
            users[j].editing = false;
            if (users[j].producer === undefined) {
              newUsers.push(users[j]);
            }
          }
        }
        vm.items = newUsers;
      });
    };

    load(1);

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

    vm.add = function(item){
      PublisherAdminService.addUserProducer($stateParams.parentId, item.id).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.createUser = function(item){
      UsersService.signup(item).then(function(){
        vm.create = false;
        load(vm.pagination.current);
      });
    };

    vm.addUser = function(){
      vm.create = true;
      vm.items.push({
        id: 0,
        name: '',
        email: '',
        password: '',
        editing: true,
      });
    };
  }

})();
